import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/core/guards/auth.guard';
import { Logged } from './modules/core/guards/logged.guard';
import { NotFoundComponent } from './modules/core/layouts/not-found/not-found.component';

const appRoutes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: 'sign-in',
		loadChildren: () => import('./modules/sign-in/sign-in.module').then((m) => m.SignInModule),
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./modules/dashboard/main/main.module').then((m) => m.MainModule),
	},
	{
		path: 'not-found',
		component: NotFoundComponent,
	},

	{
		path: '**',
		redirectTo: 'not-found',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes)],
	exports: [RouterModule],
	providers: [AuthGuard, Logged],
})
export class AppRoutingModule {}
